import { Component, OnDestroy, OnInit,Output,EventEmitter,ElementRef,ViewChild  } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { fromEvent,Subject,Subscription } from 'rxjs';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/gastro.service';
import { GastroFormsService } from 'src/app/gastro-forms.service';
import {  tap, switchMap, takeUntil, finalize} from 'rxjs/operators';


@Component({
    selector: 'app-gastro-procedure',
    templateUrl: './gastro-procedure.component.html',
    styleUrls: ['./gastro-procedure.component.scss'],
    standalone: false
})
export class GastroProcedureComponent implements OnInit, OnDestroy {
  ProcedureForm;
  SignForm;
  Signs=[];
  showScanPopup = false;
  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();
  formLoaded:Subscription
  @ViewChild("canvasSign", { static: true })
  canvasSign: ElementRef<HTMLCanvasElement>;
  changeCanvas$ = new Subject();
  destroy$ = new Subject();
  sub = new Subscription();
  ctx: CanvasRenderingContext2D;
  constructor(private fb:UntypedFormBuilder,public gfs: GastroFormsService , public gs:UsgService) { }
  ngOnInit() {
    this.resetSignForm();
    this.formLoaded = this.gfs.formLoaded$.subscribe(
      (data: any) => {
        if (this.gfs.Form && this.gfs.Form.get('AutoIndex').value) {
          this.loadSigns();
        }
        if (this.gfs.Form && this.gfs.Form.get('nurseSign').value) {
          // NURSE SIGN
          this.loadSign();
        }
        if(this.gfs.Form && !this.gfs.Form.get("CreationTime").value){
          this.gfs.Form.get("CreationTime").setValue(new Date(), { emitEvent: false })
        }
      })
    }

  resetSignForm(){
    const currentDate = new Date();
    this.SignForm = this.fb.group({
      CreationTime:[''],
      Blood:[''],
      Pulse:[''],
      Saturation:[''],
      Oxygen:[''],
      bpSystolic:[''],
      bpDyastolic:[''],
      Hour:[currentDate.getHours()],
      Min:[currentDate.getMinutes()]
    })
  }

  loadSigns(){
    var res = this.gfs.getAllSigns();
    res.subscribe((data:any) =>{
      this.Signs = data;
    })
  }
  saveSigns(){
    if(this.SignForm.touched){
      const currentDate = new Date();
      const timeZoneOffset = currentDate.getTimezoneOffset();
      currentDate.setMinutes(currentDate.getMinutes() - timeZoneOffset);
        // Extract hour and minute values from form controls
    const hour = this.SignForm.get('Hour').value || currentDate.getHours();
    const minute = this.SignForm.get('Min').value || currentDate.getMinutes();

    // Set the hour and minute values in the currentDate
    currentDate.setHours(hour);
    currentDate.setMinutes(minute);
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')} ${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;

    

      this.SignForm.get('CreationTime').setValue(formattedDate);

      this.gfs.saveSign(this.SignForm.value).subscribe(()=>{
        this.loadSigns()
        this.resetSignForm();

      })//(this.SignForm, 'signs', false, true)
      // this.Signs.push(this.SignForm.value)
    }
  }
  setTime(){
    var now = new Date()
    this.ProcedureForm.get('EndTime').setValue(now)
  }

  ngOnDestroy(): void {
    if(this.formLoaded)
    this.formLoaded.unsubscribe()
  }

  printForm(){
    this.print.emit('1')
  }

  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }

  clearSign() {
    var ctx = this.canvasSign.nativeElement.getContext("2d");
    ctx.clearRect(
      0,
      0,
      this.canvasSign.nativeElement.width,
      this.canvasSign.nativeElement.height
    );
    this.gfs.Form.get('nurseSign').setValue('');
  

}

ngAfterViewInit(){
  this.sub = this.changeCanvas$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: any) => {
      this.ctx = data.ctx;
      const mouseDownStream = fromEvent(
        this.canvasSign.nativeElement,
        "mousedown"
      );
      const mouseMoveStream = fromEvent(
        this.canvasSign.nativeElement,
        "mousemove"
      );
      const mouseUpStream = fromEvent(window, "mouseup");
      mouseDownStream
        .pipe(
          tap((event: MouseEvent) => {
            this.ctx.beginPath();
            this.ctx.strokeStyle = "black";
            this.ctx.lineWidth = 5;
            this.ctx.lineJoin = "round";
            this.ctx.moveTo(event.offsetX, event.offsetY);
          }),
          switchMap(() =>
            mouseMoveStream.pipe(
              tap((event: MouseEvent) => {
                this.ctx.lineTo(event.offsetX, event.offsetY);
                this.ctx.stroke();
              }),
              takeUntil(mouseUpStream),
              finalize(() => {
                // this.ctx.closePath();
                this.saveSign();
              })
            )
          )
        )
        .subscribe((data) => {
          // console.log(data);
        });
    });
}


setCanvas() {
  this.ctx = this.canvasSign.nativeElement.getContext("2d");
  this.changeCanvas$.next({ canvas: this.canvasSign, ctx: this.ctx });
}

saveSign() {
  let canvasUrl = this.canvasSign.nativeElement.toDataURL("image/png");
      this.gfs.Form.get("nurseSign").setValue(canvasUrl);
     
  }

  loadSign(){
    var ctx = this.canvasSign.nativeElement.getContext("2d");
      const imgNurseSign = document.createElement("img");
      imgNurseSign.onload = function () {
        ctx.drawImage(imgNurseSign, 0, 0); // Or at whatever offset you like
      };
      imgNurseSign.src = this.gfs.Form.get("nurseSign").value;
  }

}
